/* unplugin-vue-components disabled */import { render } from "./index.vue?vue&type=template&id=1a32ceaa"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import exportComponent from "/home/jenkins/agent/workspace/chongyueyuedsn29/cyy-manage-web-new/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/layouts/basic-layout/header-setting/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1a32ceaa"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1a32ceaa', __exports__)) {
    console.log('reload')
    api.reload('1a32ceaa', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=1a32ceaa", () => {
    console.log('re-render')
    api.rerender('1a32ceaa', render)
  })

}


export default __exports__